<template>
    <cms-block v-bind="$props" @block-selected="selectBlock"
               :block-component="CmsLink" :block-component-params="{link: currentLink}">
        <cms-block-renderer v-for="child in block.children" :key="child.id" @block-selected="selectBlock"
                                :block="child" :parent="block" :block-selection="blockSelection" :editable="editable"/>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsLink from "@components/cms/cms-link.vue";

// cms-block-container #hot-reload-debug
export default {
    name: `cms-block-container`,
    components: {
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    data() {
        return {
            CmsLink
        }
    },
    computed: {
        currentLink() {
            let link;
            if (this.block.link.useBinding && this.boundItem && this.block.link.linkField) {
                link = this.boundItem.getField(this.block.link.linkField);
            }
            if (!link) {
                link = this.block.link.link;
            }
            return link;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
